import { UserDefinedTaskTypes } from "@/modules/tasks/enums";
import { JourneysResponse } from "@/modules/leads/dtos/index.v2";
import { LinkToOptions } from "@/modules/tasks/enums";
import { SelectOption } from "@/modules/tasks/types";
import { formatBidirectionalText } from "@/modules/tasks/utils";

// Task type options
export const getTaskTypeOptions = () =>
  Object.values(UserDefinedTaskTypes).map((type) => ({
    value: type,
    label: type,
  }));

// Link to options
export const getLinkToOptions = () =>
  Object.values(LinkToOptions).map((option) => ({
    value: option,
    label: option,
  }));

// Link to ID options for leads only
export const getLinkToOptionsData = (
  leadsData: JourneysResponse | undefined,
  _searchTerm?: string
): SelectOption[] => {
  return (
    leadsData?.data?.results?.map((journey: any) => ({
      uid: journey.nanoId,
      value: journey.nanoId,
      label: formatBidirectionalText(
        journey.lead?.customer?.name || "",
        journey.nanoId
      ),
    })) || []
  );
};

// Property options for property selector
export const getPropertyOptionsData = (propertiesData: any): SelectOption[] => {
  return (
    propertiesData?.data?.results?.map((track: any) => ({
      uid: track.uid,
      value: String(track.id),
      label: String(track.id),
      compound: track.property?.location?.name,
    })) || []
  );
};

// Users options for assignee
export const getUsersOptions = (assignedUsers: any) => {
  const users = assignedUsers?.usersFilterOptions || [];
  return users.map((user: any) => ({
    value: user.uid,
    label: user.name,
  }));
};
